

  // all slider
  window.SplideSliderFunction = function () {
    document.querySelectorAll('.splide:not(.no-custom-arrow):not(.CenterMoodSlider):not(.marquee-slider)').forEach((element) => {
      const perPage = parseInt(element.dataset.perPage) || 1;
      const gap = element.dataset.gap || '24px';
      const drag = element.dataset.drag === 'true';
      const arrows = element.dataset.arrows === 'true';
      const direction = element.dataset.direction;
      const height = element.dataset.height;
      const autoplay = element.dataset.autoplay === 'true';
      const autoplayintervel = parseInt(element.dataset.autoplayintervel);
      const type = element.dataset.type;
      const paginatione = element.dataset.pagination == 'true';

      // Banner check
      const isBanner = element.dataset.banner === 'yes';
      const mobileshow = isBanner ? 1 : 2;


      // 👉 Get custom breakpoint values
      const br1440 = parseInt(element.dataset['1440br']);
      const br1199 = parseInt(element.dataset['1199br']);
      const br989 = parseInt(element.dataset['989br']);
      const br767 = parseInt(element.dataset['767br']);
      const br576 = parseInt(element.dataset['576br']);

      const splide = new Splide(element, {
        type: type,
        perPage: perPage,
        arrows: arrows,
        pagination: paginatione,
        drag: drag,
        autoplay: autoplay,
        gap: gap,
        updateOnMove: true,
        interval: autoplayintervel || 3000,
        breakpoints: {
          1440: {
            pagination: paginatione,
            drag: true,
            perPage: isBanner ? mobileshow : (br1440 || perPage),
            gap: "16px"
          },
          1199: {
            pagination: paginatione,
            drag: true,
            perPage: isBanner ? mobileshow : (br1199 || mobileshow),
            gap: "16px"
          },
          989: {
            pagination: paginatione,
            drag: true,
            perPage: isBanner ? mobileshow : (br989 || mobileshow),
            gap: "16px"
          },
          767: {
            perPage: isBanner ? mobileshow : (br767 || mobileshow),
            arrows: arrows,
            pagination: paginatione,
            gap: "10px"
          },
          576: {
            perPage: isBanner ? mobileshow : (br576 || mobileshow),
            arrows: false,
            pagination: true
          }
        }
      });

      splide.on('mounted move resized', function () {

        const totalSlides = splide.length;
        const index = splide.index;
        const perPage = splide.options.perPage;
        const lastIndex = totalSlides - perPage;

        const prevArrow = element.querySelector('.splide__arrow--prev');
        const nextArrow = element.querySelector('.splide__arrow--next');

        if (!prevArrow || !nextArrow) return;

        // Hide arrows if all slides fit
        if (totalSlides <= perPage) {
          prevArrow.style.display = 'none';
          nextArrow.style.display = 'none';
          return;
        } else {
          prevArrow.style.display = '';
          nextArrow.style.display = '';
        }

        // Reset disabled state
        prevArrow.classList.remove('disabled');
        nextArrow.classList.remove('disabled');

        // Disable prev at first slide
        if (index === 0) {
          prevArrow.classList.add('disabled');
        }

        // Disable next at last slide
        if (index >= lastIndex) {
          nextArrow.classList.add('disabled');
        }

      });


      splide.mount();


    });

  };

  SplideSliderFunction();


document.addEventListener('DOMContentLoaded', function () {

// index faq

  document.querySelectorAll(".index-faq").forEach(function (faqSection) {

    faqSection.querySelectorAll(".question").forEach(function (item) {

      item.addEventListener("click", function () {

        this.parentElement.classList.toggle("active");

        // Hide/Show answer
        const nextdiv = this.nextElementSibling;

        if (window.getComputedStyle(nextdiv).display == "none") {
          nextdiv.style.display = "block";
        } else {
          nextdiv.style.display = "none";
        }

        // Close other FAQs in the same section
        const topparent = this.parentElement.parentElement.children;

        for (let i = 0; i < topparent.length; i++) {

          const siblingcount = topparent[i];

          if (siblingcount != this.parentElement) {

            siblingcount.classList.remove("active");

            const dataText = siblingcount.querySelector(".answer");

            if (dataText) {
              dataText.style.display = "none";
            }

          }

        }

      });

    });

  });


  const checkbox = document.getElementById('ContactForm-agree');
  const submitBtn = document.getElementById('ContactForm-submit');

  if (!checkbox || !submitBtn) return;

  submitBtn.disabled = !checkbox.checked;

  checkbox.addEventListener('change', function () {
    submitBtn.disabled = !this.checked;
  });






  const anchorLinks = document.querySelectorAll('a[href^="#"]'); 

  anchorLinks.forEach(function(link) {

    link.addEventListener("click", function(e) {

      const targetId = this.getAttribute("href");

      // Ignore empty links
      if (targetId === "#") return;

      const target = document.querySelector(targetId);

      if (!target) return;

      e.preventDefault();

      target.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });

    });

  });





  //  const header = document.querySelector(".header-wrapper");

  // document.querySelectorAll('a[href^="#"]').forEach(function (link) {

  //   link.addEventListener("click", function (e) {

  //     const targetId = this.getAttribute("href");

  //     if (targetId === "#") return;

  //     const target = document.querySelector(targetId);

  //     if (!target) return;

  //     e.preventDefault();

  //     const menuDrawer = document.querySelector("menu-drawer");
  //     const details = menuDrawer ? menuDrawer.querySelector("details") : null;

  //     // Close mobile menu if open
  //     if (menuDrawer && details && details.hasAttribute("open")) {
  //       menuDrawer.closeMenuDrawer();
  //     }

  //     const headerHeight = header ? header.offsetHeight : 0;

  //     // Wait for drawer closing animation
  //     setTimeout(function () {

  //       const offsetTop =
  //         target.getBoundingClientRect().top +
  //         window.pageYOffset -
  //         headerHeight;

  //       window.scrollTo({
  //         top: offsetTop,
  //         behavior: "smooth",
  //       });

  //     }, 300);

  //   });

  // });



// end
});